module.exports = __webpack_public_path__ + "img/background-2.eba4b916.png";